import { render, staticRenderFns } from "./ConsumerProfile.vue?vue&type=template&id=5ba26d4b&scoped=true&"
import script from "./ConsumerProfile.vue?vue&type=script&lang=js&"
export * from "./ConsumerProfile.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerProfile.vue?vue&type=style&index=0&id=5ba26d4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba26d4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
